module.exports = __webpack_public_path__ + "img/D201508_3.899c08fa.jpg";